import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { createSelector } from 'reselect'
import { Button, Divider, Icon, ListItem, makeStyles, Typography, useTheme } from '@material-ui/core'
import useViewportSize from '~/components/useViewportSize'
import ifood from '~/assets/ifood-43.svg'
import { clickIfood } from '~/track'
import { useLiterals } from '~/components/Literals'

// import { Container } from './styles';

const selector = createSelector(
  (state) => state.config,
  (state) => state.app.currentProduct,
  (state) => state.position,
  (...args) => args,
)

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 8,
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: 'rgba(251, 207, 84, 0.16)',
    margin: 8,
    borderRadius: 4,
    width: 'auto',
    // maxWidth: 392
  },
  button: ({ isMobile }) => ({
    display: 'flex',
    alignItems: 'center',
    fontSize: 12,
    color: '#fff',
    backgroundColor: '#EA1D2C',
    textTransform: 'none',
    width: isMobile ? 94 : 'fit-content',
    height: 37,
    '&:hover': {
      backgroundColor: '#EA1D2C',
    },
    '& .MuiButton-startIcon': {
      marginRight: 0,
    },
  }),
  icon: { marginRight: 0, width: '35px', height: '19px' },
  divider: {
    backgroundColor: '#fff',
    height: '27px',
    margin: '0 5px',
  },
}))

function IfoodBanner({ url }) {
  const [config, currentProduct, position] = useSelector(selector)

  const viewport = useViewportSize()
  const theme = useTheme()
  const isMobile = viewport.width < theme.gofind.desktopMaxWidth
  const classes = useStyles({ isMobile })
  const { getLiteral } = useLiterals()

  const handleClickIfood = useCallback(() => {
    if (position.user) {
      clickIfood(config, currentProduct, position.user)
    }
  }, [config, currentProduct, position])

  return (
    <ListItem className={classes.root} key="ifoodButton">
      <Typography style={{ fontSize: 14 }}>{getLiteral('2593')}:</Typography>
      <Button
        className={classes.button}
        variant="contained"
        disableRipple={true}
        startIcon={
          <Icon className={classes.icon} style={{ width: '35px', height: '19px' }}>
            <img src={ifood} />
          </Icon>
        }
        href={url}
        target="_blank"
        onClick={handleClickIfood}
      >
        {!isMobile && (
          <>
            <Divider orientation="vertical" flexItem className={classes.divider} />
            <span>{getLiteral('1317')}</span>
          </>
        )}
      </Button>
    </ListItem>
  )
}

export default IfoodBanner
